import { useState, useEffect } from 'react'
import { db } from '../firebase/config'

/**
 * Alle levende inzichten onder één thema — concepten én publicaties.
 *
 * Voedt de knop 'Bekijk inzicht details' op het themadetail: die moet weten
 * of een cel al een inzicht heeft, anders maakt elke klik een nieuw concept.
 * Daarom is `loaded` een eigen toestand: zolang die false is, is 'geen
 * inzicht' geen kennis maar een gok.
 * AI-CONTEXT: See docs/pitfalls.md#ui-empty-state-claims-absence-while-loading
 * AI-CONTEXT: See docs/pitfalls.md#database-firestore-silent-listener-failure
 *
 * @param {string} themeId - '' = nog niet bekend, dan geen listener
 * @returns {{insights: Array<object>, loaded: boolean, error: (Error|null)}}
 */
const useThemeInsights = (themeId) => {
    const [insights, setInsights] = useState(/** @type {Array<object>} */([]))
    const [loaded, setLoaded] = useState(false)
    const [error, setError] = useState(/** @type {Error|null} */(null))

    useEffect(() => {
        if (!themeId) return undefined
        setLoaded(false)
        setError(null)
        const unsub = db.collection('QuestionInsights')
            .where('ThemeID', '==', themeId)
            .onSnapshot(
                (snap) => {
                    setInsights(snap.docs
                        .map((doc) => ({ docid: doc.id, ...doc.data() }))
                        .filter((insight) => insight.Deleted !== true))
                    setLoaded(true)
                },
                (err) => {
                    console.error('useThemeInsights:', themeId, err)
                    setError(err)
                    setInsights([])
                    setLoaded(false)
                },
            )
        return () => unsub()
    }, [themeId])

    return { insights, loaded, error }
}

export default useThemeInsights
